import { render } from "./regalos_ingles.vue?vue&type=template&id=65d980a0&scoped=true"
import script from "./regalos_ingles.vue?vue&type=script&lang=js"
export * from "./regalos_ingles.vue?vue&type=script&lang=js"

import "./regalos_ingles.vue?vue&type=style&index=0&id=65d980a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d980a0"]])

export default __exports__